export default {
  name: 'reviewMeeting',
  miniSave: false,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    return requestFunction
      .methodRequest('/crewconfig/annualreview/meeting', 'PUT', data)
  },
  restoreSave: (ctx) => {
    const data = ctx.saveObj.data;
    ctx.router.push({ name: `crews-crewid-safety-review-new`, params: { crewid: data.crewid }, query: { sid: ctx.saveId } });
  }
}
